import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

const VARIANTS = {
  primary: "bg-cocoa text-white shadow-cocoa hover:bg-cocoa/90",
  brand: "bg-primary text-white shadow-brand hover:bg-primary/90",
  secondary: "border-[1.5px] border-dark bg-surface text-dark hover:bg-secondary",
  outline: "border-[1.5px] border-secondary-dark bg-surface text-dark hover:bg-secondary",
  ghost: "text-primary hover:bg-primary-50",
};

const SIZES = {
  lg: "h-cta px-6 rounded-lg text-base",
  md: "h-11 px-4 rounded-md text-sm",
};

/**
 * The one button for the whole app. Use `lg` for the screen's main action and `md` for
 * everything else; pass `fullWidth` when it spans its container.
 */
const Button = forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      fullWidth = false,
      type = "button",
      className = "",
      children,
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      type={type}
      className={twMerge(
        "inline-flex items-center justify-center gap-2 font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none",
        VARIANTS[variant],
        SIZES[size],
        fullWidth && "w-full",
        className
      )}
      {...rest}
    >
      {children}
    </button>
  )
);

export default Button;
